import { render, staticRenderFns } from "./show-info.vue?vue&type=template&id=583884c5&"
import script from "./show-info.vue?vue&type=script&lang=js&"
export * from "./show-info.vue?vue&type=script&lang=js&"
import style0 from "./show-info.vue?vue&type=style&index=0&id=583884c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports